import React from 'react'
import _ from 'lodash';
import { connect } from "react-redux";

function Permission(props) {
  const { moduleName, action, onlyAdmin, currentUser, currentStore, tabConfig, children } = props;

  const canView = () => {
    if (currentUser.role === 'super_admin' || currentUser.role === 'itrust_admin') {
      return true
    } else if (currentUser.role === 'admin') {
      if (onlyAdmin)
        return onlyAdmin === 'admin';
      return true
    } else if (onlyAdmin == undefined && currentStore.store_access_level == "full") {
      return true
    } else if (currentStore.store_access_level == "restricted") {
      return false
    }
    else if (moduleName !== undefined) {
      if (moduleName === 'addOns') {
        // temporarily flow
        if (tabConfig.all_user_access && currentUser.role === 'non_admin' && currentStore.store_access_level !== 'full') {
          return tabConfig.visible ? true : false
        }
      }
      var record = _.find(currentStore.permissions, { app_module_name: moduleName })
      return record && (record.access_level === "full" || record.permissions[action])
    }
    else if (moduleName === undefined && onlyAdmin === undefined) {
      return true
    }
  }

  return (
    <>
      {canView() && children}
    </>
  )
}

const mapStateToProps = state => {
  const { currentStore, auth, organisation: { organisation } } = state;
  return {
    currentStore: currentStore.store,
    currentUser: auth.user,
    tabConfig: organisation?.add_ons_config?.type?.tab,
  }
}

export default connect(mapStateToProps)(Permission);